import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { PageHeader } from 'react-bootstrap'

import { SignupWithExternalsRecord } from 'internal-components/src/records'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'
import { selectSignupWithExternals } from 'internal-components/src/redux/modules/signup/selectors'

import PageLoading from '../../components/Layout/PageLoading'
import MspSignupCompleted from '../../components/Signup/MspCompleted'

export function FinishedView({ loading = false, signupWithExternals }) {
  return (
    <section className="container">
      <PageHeader>
        {signupWithExternals &&
          signupWithExternals.signup.reference && (
            <small className="pull-right">
              {signupWithExternals.signup.reference}
            </small>
          )}
        Signup Created
      </PageHeader>

      {loading && <PageLoading />}
      {signupWithExternals &&
        signupWithExternals.offer && (
          <MspSignupCompleted signupWithExternals={signupWithExternals} />
        )}
    </section>
  )
}

FinishedView.propTypes = {
  loading: Pt.bool,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord),
}

const mapStateToProps = () => {
  const selectLoading = makeSelectLoading()
  const selectSignupLoading = makeSelectLoading()

  return (state, { params }) => ({
    loading:
      selectLoading(state, { type: ['products', 'offers'] }) ||
      selectSignupLoading(state, { type: 'signup', keys: params.reference }),
    signupWithExternals: selectSignupWithExternals(state, {
      reference: params.reference,
    }),
  })
}

export default connect(mapStateToProps)(FinishedView)



// WEBPACK FOOTER //
// ./src/views/Msp/FinishedView.jsx